import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { OpusPanel, OpusButton } from '../opus-ai';
import { CommandPalette } from '../search/CommandPalette';

export function Layout() {
  return (
    <div className="min-h-screen bg-bg-primary">
      <Sidebar />
      <Header />
      <main className="lg:ml-64 pt-16 min-h-screen">
        <div className="p-4 lg:p-6">
          <Outlet />
        </div>
      </main>

      {/* Global Search */}
      <CommandPalette />

      {/* Opus AI Assistant */}
      <OpusPanel />
      <OpusButton />
    </div>
  );
}
